import './button.scss';

import { Button } from './button';

export const SaveBtn = ({
	handleSave,
	disabled,
	style,
}: {
	handleSave: VoidFunction;
	disabled?: boolean;
	style?: React.CSSProperties;
}) => {
	return (
		<Button style={{ width: '250px', display: 'block', ...style }} onClick={handleSave} disabled={disabled}>
			Сохранить
		</Button>
	);
};
